import { render, staticRenderFns } from "./ActivityPrices.vue?vue&type=template&id=35b4b6b5"
import script from "./ActivityPrices.vue?vue&type=script&lang=ts"
export * from "./ActivityPrices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports